import { FunctionComponent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import Keyframes from "theme/keyframes";

type Props = {
  className?: string;
};

const StyledComboEvent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 8px;
  background: #ddb003;
  border-bottom-right-radius: 5px;
  animation: ${Keyframes.blink()} ease-out 1s infinite;
`;

const ComboEvent: FunctionComponent<Props> = ({ className }) => {
  return (
    <StyledComboEvent className={className} style={{}}>
      <FontAwesomeIcon icon={faLink} />
    </StyledComboEvent>
  );
};

export default ComboEvent;
